export const API_KEY = "AIzaSyAXtrZ3YNyCjpE0MvENrn8RjOdwIB5gjGA";

export default API_KEY;
